"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var renderIcon = function (_a) {
    var Icon = _a.Icon, node = _a.node, iconSelector = _a.iconSelector, position = _a.position;
    var className = (0, classnames_1.default)('tree-icon text-default flex-shrink-0', position === 'right' ? 'ms-3' : 'me-3');
    if (Icon)
        return ((0, jsx_runtime_1.jsx)(Icon, { className: className, "data-testid": "node-icon-".concat(node.id), "data-icon": Icon.name }));
    if (iconSelector) {
        var IconRender = iconSelector(node);
        if (IconRender) {
            return ((0, jsx_runtime_1.jsx)(IconRender, { className: className, "data-testid": "node-icon-".concat(node.id), "data-icon": IconRender.name }));
        }
    }
    return null;
};
exports.renderIcon = renderIcon;
